import LoadingLottie from "../Lottie/Loading";

const Loader = () => {
    return (
        <div
            style={{
                width: "max-content",
                height: "max-content",
                margin: "auto",
            }}
        >
            <LoadingLottie />
        </div>
    );
};
export default Loader;
